module.exports = __webpack_public_path__ + "img/0g.dc9b07f2.svg";